// 根据菜单名称匹配语义图标；业务关键词优先于“小区、物业”等通用词
const MENU_ICON_RULES = [
  { keywords: ['首页', '主页', '工作台', '控制台', 'home', 'dashboard'], icon: 'fa-home' },
  { keywords: ['报表', '统计', '分析', '看板', 'report', 'statistics', 'analysis'], icon: 'fa-bar-chart' },
  { keywords: ['收费', '缴费', '账单', '财务', '费用', '发票', 'fee', 'pay', 'bill', 'finance'], icon: 'fa-cny' },
  { keywords: ['工单', '报修', '投诉', '巡检', '任务', 'work', 'repair', 'complaint', 'inspection'], icon: 'fa-list-alt' },
  { keywords: ['门禁', '通行', '访客', '钥匙', 'access', 'visitor'], icon: 'fa-id-card-o' },
  { keywords: ['车辆', '停车', '车位', 'car', 'parking'], icon: 'fa-car' },
  { keywords: ['房屋', '楼宇', '楼栋', '房产', '单元', '房间', 'room', 'house', 'building'], icon: 'fa-building' },
  { keywords: ['业主', '住户', '客户', '成员', 'owner', 'resident', 'customer'], icon: 'fa-user-o' },
  { keywords: ['员工', '组织', '部门', '角色', '人员', 'staff', 'organization', 'role'], icon: 'fa-users' },
  { keywords: ['设备', '物联', 'iot', 'device', 'equipment'], icon: 'fa-hdd-o' },
  { keywords: ['合同', '档案', '文档', 'contract', 'archive'], icon: 'fa-file-text-o' },
  { keywords: ['采购', '仓库', '物品', '物资', '资源', 'purchase', 'warehouse', 'resource'], icon: 'fa-cubes' },
  { keywords: ['商城', '商户', '商品', '订单', 'mall', 'merchant', 'product', 'order'], icon: 'fa-shopping-bag' },
  { keywords: ['公告', '消息', '通知', 'notice', 'message'], icon: 'fa-bell-o' },
  { keywords: ['流程', '审批', '办公', 'oa', 'workflow', 'approval'], icon: 'fa-sitemap' },
  { keywords: ['活动', '场地', '预约', '会议', 'activity', 'venue', 'booking'], icon: 'fa-calendar-check-o' },
  { keywords: ['服务', '便民', 'service'], icon: 'fa-heart-o' },
  { keywords: ['小区', '社区', '物业', 'community', 'property'], icon: 'fa-building-o' },
  { keywords: ['开发', '配置', '系统', '设置', '权限', 'dev', 'config', 'system', 'setting'], icon: 'fa-cog' }
]

export function resolveMenuIcon(menu) {
  const name = String(menu && menu.name ? menu.name : '').toLowerCase()
  const matchedRule = MENU_ICON_RULES.find(rule =>
    rule.keywords.some(keyword => name.includes(keyword.toLowerCase()))
  )

  if (matchedRule) return matchedRule.icon

  const backendIcon = String(menu && menu.icon ? menu.icon : '')
    .split(/\s+/)
    .find(className => /^fa-[\w-]+$/.test(className))

  return backendIcon || 'fa-circle-o'
}
